module.exports = __webpack_public_path__ + "static/media/1_10.83ff4bfa.jpg";